var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoRoomContainer',{attrs:{"booking":_vm.booking,"coach":null,"guestMode":true,"sessionRole":"guest"},on:{"guestSessionClosed":function($event){return _vm.$emit('ended')},"sessionEnded":function($event){_vm.hasEnded = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }